document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.blog-post-content ul').forEach(function (ul) {
    const items = Array.from(ul.querySelectorAll(':scope > li'));
    if (!items.length) return;

    const rows = items.map(function (li) {
      const text = li.textContent.trim();
      const idx = text.indexOf(':');
      if (idx === -1) return { label: text, value: '' };
      return {
        label: text.slice(0, idx).trim(),
        value: text.slice(idx + 1).trim()
      };
    });

    const table = document.createElement('table');
    table.className = 'spec-table';

    rows.forEach(function (row) {
      const tr = document.createElement('tr');

      const th = document.createElement('th');
      th.textContent = row.label;
      tr.appendChild(th);

      const td = document.createElement('td');
      td.textContent = row.value;
      tr.appendChild(td);

      table.appendChild(tr);
    });

    ul.replaceWith(table);
  });
});